function RegisteredCorporates() {
    return (
      <>
        <div className="font-bold text-lg mb-16">RegisteredCorporates</div>
      </>
    );
  }
  
  export default RegisteredCorporates;